export const HOME = { emergentLink: "emergent-link" };

export const LANDING = {
  navLogo: "nav-logo",
  navShop: "nav-shop-link",
  navHow: "nav-how-link",
  navReviews: "nav-reviews-link",
  navFaq: "nav-faq-link",
  navCta: "nav-cta-button",
  announcementBar: "announcement-bar",
  countdownTimer: "countdown-timer",
  heroCta: "hero-cta-button",
  heroHeadline: "hero-headline",
  socialTicker: "social-proof-ticker",
  shopZone: "shop-zone",
  bundleCard: (qty) => `bundle-card-${qty}`,
  sizeQueen: "size-queen-button",
  sizeKing: "size-king-button",
  addToCart: "add-to-cart-button",
  galleryMain: "gallery-main-image",
  galleryThumb: (idx) => `gallery-thumb-${idx}`,
  finalCta: "final-cta-button",
  countdownUrgency: "countdown-urgency",
  reviewsSection: "reviews-section",
  faqAccordion: "faq-accordion",
  faqItem: (i) => `faq-item-${i}`,
  exitPopup: "exit-intent-popup",
  exitPopupEmail: "exit-popup-email-input",
  exitPopupSubmit: "exit-popup-submit",
  exitPopupClose: "exit-popup-close",
  liveNotif: "live-notification",
  stickyMobileCta: "sticky-mobile-cta",
  footer: "site-footer",
};
